import { Product } from './model/product.model';
import { SUBTYPE_MAPPING } from './model/subtype.model';

export function numberFormatter(params: any): any {
  if (params.value == null || isNaN(params.value)) {
    return '';
  }
  return Math.round(params.value * 1000) / 1000;
}

export function compareNumbers(number1: any, number2: any) {
  if (number1 === null && number2 === null) {
    return 0;
  }
  if (number1 === null) {
    return -1;
  }
  if (number2 === null) {
    return 1;
  }
  return number1 - number2;
}

export function compareNumbersOrStrings(a: any, b: any) {
  const aNumber = Number(a);
  const bNumber = Number(b);
  const aWord = String(a);
  const bWord = String(b);

  if (!isNaN(aNumber) && !isNaN(bNumber)) {
    return aNumber - bNumber;
  } else {
    return aWord.localeCompare(bWord);
  }
}

export function compareVersions(version1: any, version2: any): number {
  function parseToNumber(value: any): number {
    if (value === null || value === undefined || value === '') {
      return NaN;
    }
    const parsed = parseFloat(value.toString().trim());
    return isNaN(parsed) ? NaN : parsed;
  }

  const num1 = parseToNumber(version1);
  const num2 = parseToNumber(version2);

  if (isNaN(num1) && isNaN(num2)) return 0;
  if (isNaN(num1)) return -1;
  if (isNaN(num2)) return 1;

  return num1 - num2;
}



export function dataFileNameFormatter(params: any) {
  if (params === null || params === undefined) {
    return null;
  }
  if (params.node === null || params.node === undefined) {
    return null;
  }
  if (params.node.data === null || params.node.data === undefined) {
    return null;
  }
  const product: Product = params.node.data;
  if (product.data_file_available) {
    return `${product.data_file_name} *`;
  } else {
    return product.data_file_name;
  }
}


export function getReadableSubtype(data: any): string {
  if (data === null || data === undefined) {
    return '';
  }
  const subtype = data.subtype;
  return SUBTYPE_MAPPING[subtype] || subtype;
}



export function alphaNumericComparator(valueA: string, valueB: string): any {
  // Use regex to split the string into numeric and non-numeric parts

  if (valueA === undefined || valueA === null) {
    valueA = '';
  }
  if (valueB === undefined || valueB === null) {
    valueB = '';
  }

  // Convert to lowercase for case-insensitive comparison
  const normalizedA = String(valueA).toLowerCase();
  const normalizedB = String(valueB).toLowerCase();

  const regex = /(\d+|\D+)/g;
  const aParts: string[] = normalizedA.match(regex) || [];
  const bParts: string[] = normalizedB.match(regex) || [];

  // Compare each corresponding part
  const len = Math.min(aParts.length, bParts.length);
  for (let i = 0; i < len; i++) {
    const aPart = aParts[i];
    const bPart = bParts[i];
    // Try converting parts to numbers
    const aNum = parseInt(aPart, 10);
    const bNum = parseInt(bPart, 10);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      // If both parts are numbers, compare numerically
      if (aNum !== bNum) {
        return aNum - bNum;
      }
    } else {
      // Otherwise compare as strings
      if (aPart !== bPart) {
        return aPart.localeCompare(bPart);
      }
    }
  }
  // If all parts compared equal, the one with more parts comes later.
  return aParts.length - bParts.length;
}
